require('./editDaysDialog.less');


class EditDaysController {
    activeLine;
    activeYear;
    activeMonth;
    forecast;

    constructor(private $mdDialog, private Prognosis, private toastService){
    }

    $onInit(){
        this.Prognosis.getForecastsPerDay({articleNo: this.activeLine.articleNo, forecastTypeId: this.activeLine.id, month: this.activeMonth, year: this.activeYear}).$promise.then(
            (result) => {
                this.forecast = result;
            },
            (error) => this.toastService.parseError(error)
        );
    };

    save (){
        this.Prognosis.postForecastsPerDay(this.forecast).$promise.then(
            () => {
                var sum = 0;
                this.forecast.forecastDays.forEach(function(day){
                    if(day.forecast != null && day.forecast > 0){
                        sum += parseInt(day.forecast);
                    }
                });
                this.activeLine.forecastLine.months[this.activeMonth-1].forecastSum = sum;
                this.hide();
            },
            (error) => this.toastService.parseError(error)
        );
    };

    hide () {
        this.$mdDialog.hide();
    };

    cancel () {
        this.$mdDialog.cancel();
    };

}

class EditDaysOptions implements ng.IComponentOptions {
    controllerAs =  'c';
    public controller:string = "editDaysDialogController";
    public template: any = require('./editDaysDialog.html');
    bindings: any = {
        activeLine:'=',
        activeMonth:'=',
        activeYear:'='
    };

}

rkcApp.controller("editDaysDialogController", ['$mdDialog', 'Prognosis', 'toastService', function ($mdDialog, Prognosis, toastService) {
    return new EditDaysController($mdDialog, Prognosis, toastService);
}])
    .component("editDaysDialog", new EditDaysOptions());



/** WEBPACK FOOTER **
 ** ./src/app/components/main/views/prognosis/editDaysDialog/editDaysDialog.ts
 **/